import { Box, Divider, Paper, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import { FilterBar } from "./FilterBar";
import { useAnalyticsFilters } from "./hooks/useAnalyticsFilters";
import { useMenuItemsAnalytics } from "./hooks/useMenuItemsAnalytics";
import { MenuItemsTable } from "./MenuItemsTable";
import { MenuAnalyticsEmptyState } from "./states";
import { SummaryCards } from "./SummaryCards";

export const MENU_ITEMS_TAB = "Menu Items";
export const INGREDIENTS_TAB = "Ingredients";

export const MenuAnalyticsDashboard = () => {
  const [selectedTab, setSelectedTab] = useState<string>(MENU_ITEMS_TAB);
  const { filters, setTimeRange, setCustomRange, setMealPeriod, setTeamId, setSort, setPage, setPageSize } =
    useAnalyticsFilters();
  const { data, loading, error } = useMenuItemsAnalytics(filters);

  return (
    <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 2 }}>
      <FilterBar
        filters={filters}
        setTimeRange={setTimeRange}
        setCustomRange={setCustomRange}
        setMealPeriod={setMealPeriod}
        setTeamId={setTeamId}
        setSort={setSort}
        setPage={setPage}
        setPageSize={setPageSize}
      />

      <SummaryCards summary={data?.summary ?? null} loading={loading} error={error} />

      <Paper variant="outlined" sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <Tabs
          value={selectedTab}
          onChange={(_, value) => setSelectedTab(value)}
          sx={{ px: 2, minHeight: 48 }}
        >
          <Tab label={MENU_ITEMS_TAB} value={MENU_ITEMS_TAB} sx={{ textTransform: "none", fontWeight: 600 }} />
          <Tab label={INGREDIENTS_TAB} value={INGREDIENTS_TAB} sx={{ textTransform: "none", fontWeight: 600 }} />
        </Tabs>
        <Divider />

        {selectedTab === MENU_ITEMS_TAB ? (
          <MenuItemsTable
            data={data}
            loading={loading}
            error={error}
            sortBy={filters.sortBy}
            sortDir={filters.sortDir}
            page={filters.page}
            pageSize={filters.pageSize}
            onSort={setSort}
            onPageChange={setPage}
            onPageSizeChange={setPageSize}
          />
        ) : (
          <MenuAnalyticsEmptyState label={INGREDIENTS_TAB} />
        )}
      </Paper>
    </Box>
  );
};
